import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-home" }

import CommonDatePicker from "@/components/common/CommonDatepicker.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const singleDate = ref<Date | null>(null);
const rangeStart = ref<Date | null>(null);
const rangeEnd = ref<Date | null>(null);

function onSingleUpdate(
  _start?: Date | null,
  _end?: Date | null,
  date?: Date | null
) {
  singleDate.value = date ?? null;
}

function onRangeUpdate(start?: Date | null, end?: Date | null) {
  rangeStart.value = start ?? null;
  rangeEnd.value = end ?? null;
}

const items = [
  { value: "1", name: "Item 1" },
  { value: "2", name: "Item 2" },
  { value: "3", name: "Item 3" },
];

const selected = ref<string | number>("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CommonDatePicker, {
      mode: "single",
      clearable: true,
      placement: "bottom",
      onUpdate: onSingleUpdate
    }),
    _createElementVNode("p", null, "Выбрана: " + _toDisplayString(singleDate.value?.toLocaleDateString() || "не выбрано"), 1),
    _createVNode(CommonDatePicker, {
      mode: "range",
      clearable: true,
      placement: "bottom",
      onUpdate: onRangeUpdate
    }),
    _createVNode(CommonDatePicker, {
      mode: "range",
      isTwoSided: true,
      clearable: true,
      maxDaysRange: 30,
      placement: "bottom",
      onUpdate: onRangeUpdate
    }),
    _createVNode(CommonDatePicker, {
      mode: "range",
      clearable: true,
      defaultRange: {
        fromDate: new Date(2026, 3, 1),
        toDate: new Date(2026, 3, 14),
      },
      onUpdate: onRangeUpdate
    }, null, 8, ["defaultRange"]),
    _createVNode(CommonDropdown, {
      modelValue: selected.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
      items: items,
      label: "Выберите",
      position: "bottom"
    }, null, 8, ["modelValue"])
  ]))
}
}

})